define("collect/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _routes.default)(function () {
    this.route('index');
    this.route('restricted', {
      path: 'restricted/:page'
    });
    this.route('profile', {
      path: '/:social_profile_slug'
    }, function () {
      this.route('tags', {
        path: '/tags/:id'
      }, function () {
        this.route('media', {
          path: '/:media_id'
        });
      });
    });
    this.route('mentions', function () {
      this.route('media', {
        path: '/:media_id'
      });
    });
    this.route('ig-profile', function () {
      this.route('media', {
        path: '/:media_id'
      });
    });
    this.route('tags', function () {
      this.route('media', {
        path: '/:media_id'
      });
    });
    this.route('contribute', function () {
      this.route('edit', {
        path: '/:media_item_id'
      });
    });
    this.route('submissions', {
      path: '/contributions/:type'
    }, function () {
      this.route('view', {
        path: '/:media_item_id'
      });
      this.route('manage');
    });
    this.route('contributions_start');
  });
});